import React from "react";
import ReactDOM from "react-dom";
import "./assets/scss/styles.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import TagManager from "react-gtm-module";

const ENV = window.ENV[window.location.hostname] || window.ENV.default;
if (ENV.GTM_ID) TagManager.initialize({ gtmId: ENV.GTM_ID });

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
